import React, { useState, useEffect } from 'react';
import { InputText } from 'primereact/inputtext';
import './style.scss';
import { Button } from 'primereact/button';
import { Fieldset } from 'primereact/fieldset';
import { allocationService } from "../../../services";
import { json, useLocation } from "react-router-dom";
import { useFormik } from "formik";
import moment from "moment";
import { toast } from "react-toastify";
import { Calendar } from 'primereact/calendar';
import { selectData, projectPoNumber } from "../../../services/store/userSlice";
import { useSelector } from "react-redux";
import { Dropdown } from "primereact/dropdown";
import { currencies } from "../../../common/util/constants";

export default function ProjectPoNumber() {
    const projectDetailData = useSelector(selectData);
    const projectPoNumStatus = useSelector(projectPoNumber);
    const [selectedCurrency, setSelectedCurrency] = useState({});
    const { search } = useLocation();
    const projectId = new URLSearchParams(search).get("projectId");
    useEffect(() => {
        if (projectDetailData.PoProject) {
            const cList = currencies.find(x => x.code === projectDetailData?.PoProject?.currency);
            formik.setFieldValue("poNumber", projectDetailData?.PoProject.poNumber);
            formik.setFieldValue("expiryDate", new Date(projectDetailData?.PoProject.expiryDate));
            formik.setFieldValue("poAmount", projectDetailData?.PoProject.amount);
            formik.setFieldValue("selectedCurrencyCode", cList);
        }
    }, [projectDetailData, currencies]);

    const formik = useFormik({
        initialValues: {
            poNumber: "",
            expiryDate: "",
            poAmount: "",
        },
        validate: (data) => {
            let errors = {};
            if (!data.poNumber) {
                errors.poNumber = "PO number is required.";
            }
            if (!data.expiryDate) {
                errors.expiryDate = "Select PO expire date.";
            }
            return errors;
        },
        onSubmit: (data) => {
            let params = {
                projectId: projectId,
                poNumber: data.poNumber,
                expiryDate: moment(data.expiryDate).format("YYYY-MM-DD"),
                amount: data.poAmount,
                currency: data.selectedCurrencyCode.code,
            };
            try {
                allocationService.updateProjectPoNumber(params).then(
                    (resp) => {
                        formik.resetForm();
                        toast.info("PO number updated successfully...");
                    },
                    (resp) => {
                        toast.error(resp.response.data.error);
                    }
                );
            } catch (error) {
                toast.error("Unable to update...");
            }
        },
    });

    const isFormFieldValid = (name) =>
        !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return (
            isFormFieldValid(name) && (
                <small className="p-error">{formik.errors[name]}</small>
            )
        );
    };

    const changeCurrency = (e) => {
        setSelectedCurrency(e.value);
        formik.setFieldValue("selectedCurrencyCode", e.value);
    }
    return (
        <>
            {!projectPoNumStatus ? (
                <div className="col grid update_project">
                    
                    <div className="col-12 label pl-3">
                        <Fieldset legend="Update Project PO Number">
                            <form onSubmit={formik.handleSubmit} className="p-fluid p-grid">
                                <div className="col grid">
                                    <div className="col-6 mt-1">
                                        <strong style={{ fontSize: '16px', fontWeight: '400' }}>PO Number : </strong>
                                    </div>
                                    <div className="col-6 mt-1">
                                        <InputText value={formik.values.poNumber} onChange={formik.handleChange} className='inputPercentage' id="poNumber" name="poNumber" />
                                        {getFormErrorMessage('poNumber')}
                                    </div>
                                </div>
                                <div className="col grid">
                                    <div className="col-6 mt-2">
                                        <strong style={{ fontSize: '16px', fontWeight: '400' }}>Expiry Date</strong>
                                    </div>
                                    <div className="col-6">
                                        <Calendar id="expiryDate" name="expiryDate" value={formik.values.expiryDate} onChange={formik.handleChange} placeholder="Date" showIcon dateFormat="dd/mm/yy" />
                                        {getFormErrorMessage('expiryDate')}
                                    </div>
                                    
                                </div>
                                <div className="col grid">
                                    <div className="col-6 mt-2">
                                        <strong style={{ fontSize: '16px', fontWeight: '400' }}>Amount</strong>
                                    </div>
                                    <div className="col-6">
                                        <div className="grid">
                                            <div className="col-6">
                                                <div className="field-checkbox">
                                                    <Dropdown name="selectedCurrencyCode" value={formik.values.selectedCurrencyCode} onChange={(e) => changeCurrency(e)} options={currencies} optionLabel="name" placeholder="Select Currency" className="w-full" />
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="field-checkbox">
                                                    <InputText max={100} value={formik.values.poAmount} onChange={formik.handleChange} className='inputPercentage' id="poAmount" name="poAmount" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col grid">
                                    <div className="col-12">
                                        <div className='text-right'>
                                            <Button type="submit" label="UPDATE" style={{display: "inline-block", width: "auto"}} />
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </Fieldset>
                    </div>
                </div>
            ) : (
                <i className='pi pi-exclamation-triangle' style={{ color: 'red' }}> PO Number already applied on project!</i>
            )}
        </>
    )
}
